export const monitoringUrl = "https://truck-tracking-qa.com/api/v1";
